// Recovered compiled webpack factory 98301. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  function r() {
    return "?dpl=dpl_6RLyVc3L2qK5GpvsjXmfExxYVxRH";
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "getDeploymentIdQueryOrEmptyString", {
      enumerable: !0,
      get: function () {
        return r;
      },
    }));
}
